import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Label, Row, Spinner } from 'reactstrap';
import CBToolTip from '../../../components/CBToolTip';
import { PostData, PostDataWithApiKey } from '../../../services/FetchData';
import Cookies from 'js-cookie';

const AiAssistantMagentoSettings = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [websiteKeys, setWebsiteKeys] = useState([]);
	const [isAddingStore, setIsAddingStore] = useState(false);
	const [copyTexts, setCopyTexts] = useState({
		apiKey: "Copy to clipboard",
		//openApiKey: "Copy to clipboard",
	});

	// Keys to display in order
	const hardcodedKeys = [
		{ key: 'apiKey', label: 'Api Key' },
		//{ key: 'openApiKey', label: 'Open Api Key' },
	];

	useEffect(() => {
		// Get websiteKeys from location state
		if (location.state && location.state.websiteKeys) {
			setWebsiteKeys(location.state.websiteKeys);
		} else {
			// If no websiteKeys in state, redirect back to form
			navigate("/getStarted/aiAssistantMagento", { replace: true });
		}
	}, [location.state, navigate]);

	// Get value for a specific key from websiteKeys array
	const getValueForKey = (keyName) => {
		const keyItem = websiteKeys.find(item => item.websiteIntegrationKey === keyName);
		return keyItem ? keyItem.websiteIntegrationValue || "" : "";
	}

	const handleCopy = (key, value) => {
		if (value) {
			navigator.clipboard.writeText(value).then(() => {
				setCopyTexts(prev => ({
					...prev,
					[key]: "Copied"
				}));
				setTimeout(() => {
					setCopyTexts(prev => ({
						...prev,
						[key]: "Copy to clipboard"
					}));
				}, 2000);
			}).catch(err => {
				console.error('Failed to copy text: ', err);
			});
		}
	}

	const handleGoToDashboard = async (e) => {
		e.preventDefault();
		e.stopPropagation();
		
		const storeURL = location.state?.storeURL;
		const apiKey = getValueForKey('apiKey');
		
		if (!storeURL) {
			// If no store URL, just navigate
			navigate("/user/dashboard");
			return;
		}

		if (!apiKey) {
			console.error("No API key found, cannot call addStore API");
			// Navigate to dashboard even without API key
			navigate("/user/dashboard");
			return;
		}

		setIsAddingStore(true);
		
		// Call add to store API
		// Backend expects: { store: { url: storeURL } }
		// Backend also expects API key in header: cb-api-key
		const requestData = {
			store: {
				url: storeURL
			}
		};

		PostDataWithApiKey("ms1", "api/v1/magento/addStore", requestData, apiKey).then(result => {
			setIsAddingStore(false);
			if (result !== "Invalid" && result !== undefined) {
				if (result.status === "success") {
					// Fetch updated user details to get the newly added store
					PostData("ms1", "api/v1/user/getUserDetail").then(userDetailResult => {
						if (userDetailResult && userDetailResult.status === "success" && userDetailResult.data.websites) {
							// Find the website that matches the storeURL we just added
							const matchingWebsite = userDetailResult.data.websites.find(website => {
								// Normalize URLs for comparison (remove trailing slashes, http/https)
								const websiteUrl = (website.websiteURL || "").replace(/\/$/, "").toLowerCase();
								const addedUrl = storeURL.replace(/\/$/, "").toLowerCase();
								return websiteUrl === addedUrl || websiteUrl.includes(addedUrl) || addedUrl.includes(websiteUrl);
							});
							
							if (matchingWebsite && matchingWebsite.websiteId) {
								// Set the newly added store as the current store
								Cookies.set('_website_id', matchingWebsite.websiteId);
								console.log("Set newly added store as current:", matchingWebsite.websiteId, matchingWebsite.websiteURL);
							}
						}
						// Reload the page to refresh the store list in dashboard
						window.location.href = "/user/dashboard";
					}).catch(() => {
						// Even if getUserDetail fails, navigate to dashboard
						window.location.href = "/user/dashboard";
					});
				} else if (result.status === "failure") {
					console.warn("addStore API failure:", result.message);
					// Navigate to dashboard even if API fails
					window.location.href = "/user/dashboard";
				} else {
					console.warn("addStore API response:", result);
					window.location.href = "/user/dashboard";
				}
			} else {
				window.location.href = "/user/dashboard";
			}
		}).catch((error) => {
			console.error("addStore API error:", error);
			setIsAddingStore(false);
			// Navigate to dashboard even if API fails
			window.location.href = "/user/dashboard";
		});
	}

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>AI Assistant Magento Settings</h2>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='align-items-center justify-content-center'>
						<Col xs={12} lg={4}>
							<div className='cardDisplay cardDisplayBody'>
								<div className='d-flex flex-column' style={{ minHeight: '100%' }}>
									{/* <h3 className="cbDisplaySmall fw-semi-bold mb-4">AI Assistant Magento Settings</h3> */}
									<p className="cbSubduedText mb-4">Use the following keys and values for your AI Assistant Magento integration.</p>
									{hardcodedKeys.map((keyConfig) => {
										const value = getValueForKey(keyConfig.key);
										return (
											<div key={keyConfig.key} className="py-1 mt-2 copyTextInputWrap">
												<Label className="fw-bold mb-2">{keyConfig.label}</Label>
												<div className="relative maxW450">
													<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
														<input 
															className="mx-3 cbNoSearchInputDecoration" 
															type="text" 
															id={`${keyConfig.key}Input`}
															ariaInvalid="false" 
															readOnly 
															value={value} 
														/>
													</div>
													<Button 
														color='link' 
														className="copyButton" 
														ariaLabel="Copy to clipboard" 
														onClick={() => handleCopy(keyConfig.key, value)}
													>
														<CBToolTip item={{ placement: 'top', text: copyTexts[keyConfig.key] || "Copy to clipboard" }} id={`${keyConfig.key}Tooltip`}>
															<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
																<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
																<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
															</svg>
														</CBToolTip>
													</Button>
												</div>
											</div>
										);
									})}
									<div className="d-flex justify-content-end mt-auto pt-4">
										<Button 
											color='primary' 
											className='cta autoWidth' 
											type="button"
											onClick={handleGoToDashboard}
											disabled={isAddingStore}
										>
											{isAddingStore ? (
												<>
													<Spinner
														className="white mr-1"
														size="sm"
														color="light"
													/>
													<span className="ml-2 d-inline-block">Loading</span>
												</>
											) : (
												"Go to Dashboard"
											)}
										</Button>
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default AiAssistantMagentoSettings;

